// This is src/App.js
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import StockComparison from './pages/StockComparison';
import StockWatchlist from './pages/StockWatchlist';
import StockVisualization from './pages/StockVisualization';
import StockRatioVisualization from './pages/StockRatioVisualization';
import StockScreener from './pages/StockScreener';
import IncomeStatement from './pages/IncomeStatement';
 import PrivacyPolicy from './pages/PrivacyPolicy';
 import Terms from './pages/Terms';
 import Contact from './pages/Contact';

import { StockComparisonProvider } from './contexts/StockComparisonContext';
import { WatchlistProvider } from './contexts/StockWatchlistContext';
import { StockScreenerProvider } from './contexts/StockScreenerContext';
import { StockVisualizationProvider } from './contexts/StockVisualizationContext';
import { StockRatioVisualizationProvider } from './contexts/StockRatioVisualizationContext';

import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

import LandingPage from './pages/LandingPage';
import GlossaryFaqPage from './pages/GlossaryFaqPage';



function AuthRedirect() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/visualization', { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  return <div>Signing in...</div>;
}

export default function App() {
  return (
    <StockVisualizationProvider>
      <StockScreenerProvider>
        <WatchlistProvider>
          <StockComparisonProvider>
            <Routes>
              {/* Default group: Layout WITHOUT the ratio provider */}
              <Route path="/" element={<Layout />}>
                <Route
                  index
                  element={
                    window.location.search.includes('code=')
                      ? <AuthRedirect />
                      // : <Navigate to="visualization" replace />
                      : <LandingPage />
                  }
                />
                <Route path="visualization" element={<StockVisualization />} />
                <Route path="watchlist" element={<StockWatchlist />} />
                <Route path="comparison" element={<StockComparison />} />
                <Route path="screener" element={<StockScreener />} />
                <Route path="income-statement" element={<IncomeStatement />} />

                  {/* // change the upper case */}
                <Route path="/landing-page" element={<LandingPage />} />

                  <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="contact" element={<Contact />} />
              <Route path="/glossary-faq" element={<GlossaryFaqPage />} />


              </Route>

              {/* Ratio group: Layout WRAPPED by StockRatioVisualizationProvider so Header can access ratio context */}
              <Route
                element={
                  <StockRatioVisualizationProvider>
                    <Layout />
                  </StockRatioVisualizationProvider>
                }
              >
                <Route path="/ratio-visualization" element={<StockRatioVisualization />} />
              </Route>
            </Routes>
          </StockComparisonProvider>
        </WatchlistProvider>
      </StockScreenerProvider>
    </StockVisualizationProvider>
  );
}
